import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import {Injectable} from '@angular/core';
import {Headers, Http, Jsonp, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';

import {environment} from '../../../environments/environment';
import {AuthBody} from '../model/authBody';
import {AuthResponse} from '../model/authResponse';
import {ErrorResponse} from '../model/errorResponse';
import {Organisation} from '../model/organisation';
import {User} from '../model/user';
import {UserProgress} from '../model/userProgress';
import { Module } from '../model/module';
import { OrganisationsDataManager } from '../organisations.datamanager';
import { ExamResult } from '../model/examResult';
import {SessionService} from './session.service';

const API_URL = environment.apiUrl;

@Injectable()
export class OrganisationsService {
  constructor(private http: Http, private sessionService: SessionService) {}

  public getAllOrganisations(): Observable<Organisation[]> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    return this.http.get(API_URL + '/v1/organisations', headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public createOrganisation(
      organisationName: string, licences: string, url: string,
      anonymised: boolean, administrator_mail_address: string): Observable<Organisation> {
    const tempHeaders = new RequestOptions({
      headers: new Headers({
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    });
    const body = {
      name: organisationName,
      number_of_licences: licences,
      logo_image_url: url,
      has_anonymised_presence_exam_results: anonymised,
      administrator_mail_address: administrator_mail_address
    };

    return this.http
        .post(API_URL + '/v1/organisations', JSON.stringify(body), tempHeaders)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public updateOrganisation(organisation: Organisation): Observable<Organisation> {
    const tempHeaders = new RequestOptions({
      headers: new Headers({
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    });
    const body = {
      name: organisation.name,
      number_of_licences: organisation.number_of_licences,
      logo_image_url: organisation.logo_image_url,
      show_eula_in_app: organisation.show_eula_in_app,
      show_privacy_policy_in_app: organisation.show_privacy_policy_in_app,
      has_anonymised_presence_exam_results: organisation.has_anonymised_presence_exam_results,
      has_anonymised_progress: organisation.has_anonymised_progress,
      is_allowed_to_save_exam_results: organisation.is_allowed_to_save_exam_results,
      is_allowed_to_save_progress: organisation.is_allowed_to_save_progress,
      administrator_mail_address: organisation.administrator_mail_address,
      force_2fa: organisation.force_2fa
    };

    return this.http
        .put(
            API_URL + '/v1/organisations/' + organisation._id,
            JSON.stringify(body), tempHeaders)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public getOrganisationById(organisationId): Observable<Organisation> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    return this.http
        .get(API_URL + '/v1/organisations/' + organisationId, headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public getProgressByOrganisation(organisationId): Observable<UserProgress[]> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    return this.http
        .get(
            API_URL + '/v1/organisations/' + organisationId + '/progress',
            headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public deleteOrganisation(organisationId): Observable<Organisation> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    return this.http
        .delete(API_URL + '/v1/organisations/' + organisationId, headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  public getExamsByOrganisation(organisationId): Observable<ExamResult[]> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    return this.http
        .get(
            API_URL + '/v1/organisations/' + organisationId + '/examresults',
            headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }

  private handleError(error: Response|any) {
    console.log(error);
    return this.sessionService.handleAuthenticatedRequestError(error);
  }

  public getAllModulesByOrganisation(organisationId: string): Observable<Module[]> {
    const headers = new RequestOptions({
      headers: new Headers(
          {'Authorization': 'Bearer ' + localStorage.getItem('token')})
    });

    return this.http.get(API_URL + '/v1/organisations/' + organisationId + '/trainings', headers)
        .map(response => {
          return response.json();
        })
        .catch(this.handleError.bind(this));
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/services/organisations.service.ts